import { ReactElement } from 'react';
import { Tooltip } from '@mui/material';
import { MaterialIcon } from '@tap/mui-ui';
import React from 'react';


export const SelectFieldCell = ({
    value,
}: {
    value: any,
}): ReactElement<any, any> => {

    if (!value) {
        return (<>{'-'}</>);
    }

    const icon = <MaterialIcon iconName={value.icon.name} sx={{ color: value.icon.color, fontSize: '20px' }} />;
    const text = value.name;

    return (
        <Tooltip title={text}>
            <div>
                {icon}
            </div>
        </Tooltip>
    )
};
